import { TableCell } from '@material-ui/core'
import i18n from 'i18next'
import EmailAlertIcon from 'mdi-react/EmailAlertIcon'
import EmailOffIcon from 'mdi-react/EmailOffIcon'
import ChipWithTooltip from '../../../components/Display/Chips/ChipWithTooltip'
import { Apartment, ApartmentStatus } from '../../../types/apartments'
import { ReservableShowings } from '../../../types/showings'
import { User, UserInterface } from '../../../types/users'
import { ApplicationAmounts } from '../../Applications/values/handleApplicationsData'

interface StatusChipsCellProps {
  apartment: Apartment
  applicationAmounts: ApplicationAmounts
  reservableShowings: ReservableShowings
  t: i18n.TFunction
  apartmentUser: User | undefined
}

const StatusChipsCell = ({
  apartment,
  t,
  applicationAmounts: { noAvailableTimes, accepted, showingReserved },
  reservableShowings,
  apartmentUser
}: StatusChipsCellProps) => {
  if (!apartment.metadata) {
    // temorary fix because atm some apartments are missing metadata object
    return <TableCell />
  }
  const {
    status,
    metadata: { adminInfo, media }
  } = apartment
  const reservableAmount =
    reservableShowings.bestReservables.length +
    reservableShowings.reservables.length
  const noReservableShowings =
    !showingReserved && (noAvailableTimes || accepted)
      ? reservableAmount === 0
      : false
  return (
    <TableCell>
      {status === ApartmentStatus.confirmed && media && (
        <ChipWithTooltip
          tooltip='Vahvistettu markkinointivalmis asunto'
          label='✔'
        />
      )}
      {status === ApartmentStatus.confirmed && !media && (
        <ChipWithTooltip tooltip='Vahvistettu, kuvat puuttuu' label='✖' />
      )}
      {adminInfo && (
        <ChipWithTooltip tooltip={t('apartment.adminInfo.label')} label='í' />
      )}
      {adminInfo && (
        <ChipWithTooltip tooltip='Apartment is in marketing' label='M' />
      )}
      {status === 'marketing' && noReservableShowings && (
        <ChipWithTooltip tooltip='Tarvitsee uusia näyttöjä' label='N' />
      )}
      {status === 'marketing' && reservableAmount > 0 && accepted > 0 && (
        <ChipWithTooltip
          tooltip='Varattavia näyttöjä ja hyväksyttyjä hakijoita jäljellä'
          label='V'
        />
      )}
      {status === ApartmentStatus.rentContractWanted && (
        <ChipWithTooltip tooltip='Rent contract wanted' label='W' />
      )}
      {(apartmentUser as UserInterface | undefined)?.emailUnconfirmed && (
        <ChipWithTooltip
          tooltip='Sähköpostia ei ole vahvistettu, varmista onko sähköposti oikein puhelussa ennen markkinointia!'
          label=''
          Icon={EmailOffIcon}
        />
      )}
      {apartment?.metadata?.createdBeforeLogin &&
        !(apartmentUser as UserInterface | undefined)?.emailUnconfirmed &&
        status === ApartmentStatus.confirmed && (
          <ChipWithTooltip
            tooltip='Luotu uudessa putkessa. Sähköposti vahvistettu, mutta varmista ennen markkinointia, että on varmasti itse vahvistanut!'
            label=''
            Icon={EmailAlertIcon}
          />
        )}
      {status === ApartmentStatus.rented && (
        <ChipWithTooltip tooltip='Rented' label='R' />
      )}
    </TableCell>
  )
}
export default StatusChipsCell
